import { render, staticRenderFns } from "./Estadias.vue?vue&type=template&id=39d42442"
import script from "./Estadias.vue?vue&type=script&lang=js"
export * from "./Estadias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports